// app/javascript/controllers/aircraft_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["trackTypeSelect", "tachSourceSection"]

    connect() {
        if (this.hasTrackTypeSelectTarget) {
            this.#updateVisibility(this.trackTypeSelectTarget.value)
        }
    }

    handleTrackTypeChange(event) {
        this.#updateVisibility(event.target.value)
    }

    #updateVisibility(value) {
        if (!this.hasTachSourceSectionTarget) return
        this.tachSourceSectionTarget.style.display = value === 'track_type_tach' ? '' : 'none'
    }
}
